// @flow
import * as React from 'react';
import { Section } from '../Section';

function SliderGroupPreview() {
  return <Section title="Slider groups">Sliders...</Section>;
}

export { SliderGroupPreview };
